
const FUNCTION_URL = process.env.REACT_APP_AI_ADJUST_URL || "";
const ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const isConfigured = () => Boolean(FUNCTION_URL);

export async function adjustSelection({ image, instruction, texts, context, aspect }) {
  if (!FUNCTION_URL) {
    return { ok: false, error: "Lumen's adjust tool is not switched on yet." };
  }
  try {
    const res = await fetch(FUNCTION_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${ANON_KEY}` },
      body: JSON.stringify({ image, instruction, texts, context, aspect }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data?.success) {
      return { ok: false, error: data?.error || `Could not adjust that (${res.status}).` };
    }
    return { ok: true, ...data };
  } catch (err) {
    console.warn("[whiteboard] adjust failed:", err?.message || err);
    return { ok: false, error: "Could not reach Lumen." };
  }
}

const aiAdjustService = { adjustSelection, isConfigured };
export default aiAdjustService;
